export default class Classify {

  static addClassName(bool: boolean, className: string | undefined, className2?: string): string {
    if (bool) {
      return ' ' + className;
    }
    return className2 ? ' ' + className2 : '';
  }

}